import React from "react";
import {  Grid, Card, CardContent, Typography, CardMedia } from '@mui/material';
import pestosteak from '../../Images/pesto steak.jpg';
import filetmignon from '../../Images/filet mignon.jpg';
import ribeyesteak from '../../Images/ribeye steak.jpg';
import dousteak from '../../Images/dou steak.jpg';
import newyorksteak from '../../Images/New york steak.jpg';
import doufiletsteak from '../../Images/dou filet steak.jpg';
import racklamb from '../../Images/rack lamb.jpg';
import wagyutomahak from '../../Images/Wagyu tomahak.webp';
import goldenwagyusteak from '../../Images/goldenwagyu stak.webp';
import canadabacon from '../../Images/canada bacon.jpg';
import japanesewagyu from '../../Images/japanese wagyu ribeye.webp';
import turfandsurf from '../../Images/turf and surf.jpg';

export const MenuItemCard: React.FC<any> = React.memo((props) => {

    const productData = [
        { image: pestosteak, name: 'Pesto Steak', amount: '₺100' },
        { image: filetmignon, name: 'Filet Mignon', amount: '₺200' },
        { image: ribeyesteak, name: 'Ribeye Steak', amount: '₺150' },
        { image: dousteak, name: 'Dou Steak', amount: '₺250' },
        { image: newyorksteak, name: 'New York Steak', amount: '₺175' },
        { image: doufiletsteak, name: 'Dou Filet Steak', amount: '₺300' },
        { image: racklamb, name: 'Rack Lamb', amount: '₺125' },
        { image: wagyutomahak, name: 'Wagyu Tomahak', amount: '₺400' },
        { image: goldenwagyusteak, name: 'Golden Wagyu Steak', amount: '₺225' },
        { image: canadabacon, name: 'Canada Bacon', amount: '₺275' },
        { image: japanesewagyu, name: 'Japanese Wagyu', amount: '₺180' },
        { image: turfandsurf, name: 'Turf & Surf', amount: '₺320' },
    ];

    return (
        <Grid sx={{ padding: '10px' }}> {/* Reduced padding */}
            <Grid container spacing={2}> {/* Reduced spacing */}
                {productData.map((product, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                        <Card sx={{ maxWidth: 200 }}> {/* Limit the card width */}
                            <CardMedia
                                component="img"
                                height="120"  /* Decreased image height */
                                image={product.image}
                                alt={product.name}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h6" sx={{ fontSize: '0.9rem' }}> {/* Reduced font size */}
                                    {product.name}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {product.amount}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    );
});
